import { Button } from '@ksyos/design-system';
import type { IServiceStartingPoint } from '../../../../../../common/interfaces/serviceWorkflow';
import { translateKey } from '../../../../../translate';
import { ProcessStartWizardButtonRow } from '../../../../elements/ProcessStartWizard/ProcessStartWizardButtonRow';

interface INewProcessStartingPointButtonRowProps {
    onClick: (startingPoint: IServiceStartingPoint) => Promise<void> | void;
    selectedStartingPointId: string | undefined;
    startingPoints: IServiceStartingPoint[];
}

export function NewProcessStartingPointButtonRow(props: INewProcessStartingPointButtonRowProps) {
    return (
        <ProcessStartWizardButtonRow label={translateKey('home.chooseStartResearch_action')}>
            {props.startingPoints.map((startingPoint) => (
                <Button
                    color="secondary"
                    key={startingPoint.id}
                    onClick={() => props.onClick(startingPoint)}
                    variant={props.selectedStartingPointId !== startingPoint.id ? 'outline' : 'solid'}
                >
                    {startingPoint.label}
                </Button>
            ))}
        </ProcessStartWizardButtonRow>
    );
}
